import React, { useEffect, useState } from "react";
import { Button, Popover } from "antd";
import { Link } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../utils/constants";
import { InfoCircleOutlined } from "@ant-design/icons";
import { CurrentUser } from "../utils/interfaces";
import { BRAND_YELLOW } from "../utils/brandTheme";

const HeaderComponent: React.FC = () => {
  const [currentUser, setCurrentUser] = useState<CurrentUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(BASE_URL + "me")
      .then((response) => {
        setCurrentUser(response.data.content);
      })
      .catch(() => {
        setCurrentUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSignIn = () => {
    axios
      .get(BASE_URL + "get-login-url")
      .then((response) => {
        window.location.href = response.data;
      })
      .catch(console.error);
  };

  const handleSignOut = () => {
    axios
      .get(BASE_URL + "logout")
      .then((response) => {
        window.location.href = response.data;
      })
      .catch(() => {
        window.location.href = "/login";
      });
  };

  const commitHash = process.env.REACT_APP_COMMIT_SHA;
  const versionContent = (
    <>
      Version:{" "}
      <span style={{ fontWeight: "bold" }}>
        v1.0.6{commitHash ? ` - ${commitHash}` : " - localHost"}
      </span>
    </>
  );

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0 20px",
        height: "100%",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <Link to="/" style={{ display: "flex", alignItems: "center", textDecoration: "none" }}>
          <img
            src="/lazer-wordmark-white.png"
            alt="Lazer Lamps"
            style={{ height: "28px", marginRight: "15px" }}
          />
          <span style={{ color: BRAND_YELLOW, fontSize: "20px", marginRight: "15px" }}>
            Canny Web App
          </span>
        </Link>
        <Popover content={versionContent} trigger="click">
          <InfoCircleOutlined style={{ color: "#8c8c8c", fontSize: "20px" }} />
        </Popover>
      </div>

      <div style={{ display: "flex", alignItems: "center" }}>
        {!loading && !currentUser && (
          <>
            <span style={{ color: "white", marginRight: 15 }}>
              You are not signed in
            </span>
            <Button type="primary" onClick={handleSignIn}>
              Sign In
            </Button>
          </>
        )}

        {currentUser && (
          <>
            <span style={{ color: "white", marginRight: 15 }}>
              Welcome, {currentUser.name} ({currentUser.roleName})
            </span>
            <Button danger type="primary" onClick={handleSignOut}>
              Logout
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default HeaderComponent;
